import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildSanctions, buildWatchlists } from './watchlistsModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Watchlists({ hits, owner, showSummary = true }) {
    const model = useMemo(() => buildWatchlists(hits, owner), [hits, owner])
    const [showPossible, setShowPossible] = useState(false)
    const { summary, strong, possible } = model

    if (!model.rows.length) return <div className={styles.calmLine}>No watchlist matches found.</div>

    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    {summary.exact > 0 && <Badge tone='declined' dot>{summary.exact} exact</Badge>}
                    {summary.strong > 0 && <Badge tone='declined'>{summary.strong} strong</Badge>}
                    {summary.possible > 0 && <Badge tone='neutral'>{plural(summary.possible, 'possible match', 'possible matches')}</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Lexis matches watchlists by name. Open a match to see the list's remarks and whether its birth year matches the owner.
            </div>

            {strong.length > 0 && <RecordList items={strong} />}

            {possible.length > 0 && strong.length > 0 && (
                <>
                    <div className={styles.listActions}>
                        <button type='button' className={styles.textButton} onClick={() => setShowPossible(v => !v)} aria-expanded={showPossible}>
                            {showPossible ? 'Hide possible matches' : `Show ${plural(possible.length, 'possible match', 'possible matches')}`}
                        </button>
                    </div>
                    {showPossible && <RecordList items={possible} />}
                </>
            )}
            {possible.length > 0 && !strong.length && <RecordList items={possible} />}
        </div>
    )
}

export function Sanctions({ sanctions, owner, showSummary = true }) {
    const model = useMemo(() => buildSanctions(sanctions, owner), [sanctions, owner])
    const { summary, rows } = model

    if (!rows.length) return <div className={styles.calmLine}>No board actions found.</div>

    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone={summary.serious ? 'declined' : 'watch'} dot={summary.serious > 0}>
                        {plural(summary.count, 'board action')}{summary.latestYear ? ` · latest ${summary.latestYear}` : ''}
                    </Badge>
                    {summary.serious > 0 && <Badge tone='declined'>{summary.serious} revoked, excluded or suspended</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Lexis matches board actions by name. Open one to see whether its date of birth matches the owner.
            </div>
            <RecordList items={rows} />
        </div>
    )
}
